var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMyOrders = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m29 12 3 4v16H12V16l3-4h14Zm1 6H14v12h16V18Zm-.5-2L28 14h-5v2h6.5ZM21 14h-5l-1.5 2H21v-2Z",
  fill: "#2D2D2D",
  fillRule: "evenodd"
})));
export default SvgMyOrders;